export const LOCAL_STORAGE_KEYS = {
  AUTH_USER_TOKEN: 'authUserToken',
};
